module.exports = __webpack_public_path__ + "media/images/alexa-store-badge-2af293fa.png";